import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Snackbar } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { getDetalleCupon } from "../../../api/ApiService";

function DetailItem({ label, value }) {
    return (
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">{label}</p>
            <p className="mt-1 text-sm font-medium text-gray-800 break-words">{value || "-"}</p>
        </div>
    );
}

function DetalleCuponPage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [dataCupon, setDataCupon] = useState(null);


    const stateToken = useSelector(state => state.reducerGlobal.token);
    const navigate = useNavigate();

    const params = useParams();

    const { id } = params;


    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleCupon();
            }
        }
    }, [id, stateToken]);


    const handleDetalleCupon = () => {
        setCargando(true);
        getDetalleCupon(stateToken?.access_token, id)
            .then(response => {
                setDataCupon(response.data);
                setCargando(false);
            })
            .catch(error => {
                console.log("error-getDetalleCupon", error);
                setCargando(false);
                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };


    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-5xl mx-auto">
                    <div className="mb-5 flex items-center justify-between gap-3">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-800">Detalle de Cupón</h1>
                            <p className="text-sm text-gray-500">Información completa del cupón seleccionado</p>
                        </div>
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-50"
                        >
                            Volver
                        </button>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {Array.from({ length: 8 }).map((_, index) => (
                                    <div key={index} className="h-20 bg-gray-200 rounded animate-pulse" />
                                ))}
                            </div>
                        </div>
                    ) : dataCupon ? (
                        <div className="space-y-5">
                            <div className="rounded-xl border border-sky-100 bg-gradient-to-r from-sky-50 to-cyan-50 p-5 shadow-sm">
                                <div className="flex flex-wrap items-start justify-between gap-4">
                                    <div>
                                        <p className="text-xs font-semibold uppercase tracking-wide text-sky-700">Cliente</p>
                                        <h2 className="mt-1 text-xl font-bold text-slate-900">{dataCupon?.cliente || "-"}</h2>
                                        <p className="mt-1 text-sm text-slate-600">CI: {dataCupon?.ci || "-"}</p>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <span className="rounded-full bg-white px-3 py-1 text-xs font-semibold text-slate-600 shadow-sm">
                                            Sorteo #{dataCupon?.sorteo_id || "-"}
                                        </span>
                                        <span
                                            className={`rounded-full px-3 py-1 text-xs font-semibold shadow-sm ${dataCupon?.anulado === "1"
                                                ? "bg-red-100 text-red-700"
                                                : "bg-emerald-100 text-emerald-700"}`}
                                        >
                                            {dataCupon?.anulado === "1" ? "Anulado" : "Activo"}
                                        </span>
                                    </div>
                                </div>
                                <p className="mt-3 text-sm text-slate-700 break-words">{dataCupon?.titulo || "-"}</p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-200">
                                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Monto</p>
                                    <p className="mt-1 text-lg font-bold text-gray-900">{dataCupon?.monto_formateado || "-"}</p>
                                </div>
                                <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-200">
                                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Cupones</p>
                                    <p className="mt-1 text-lg font-bold text-gray-900">{dataCupon?.cupones || "-"}</p>
                                </div>
                                <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-200">
                                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Moneda</p>
                                    <p className="mt-1 text-lg font-bold text-gray-900">{dataCupon?.moneda || "-"}</p>
                                </div>
                            </div>

                            <div className="rounded-xl bg-white p-5 shadow-md border border-gray-200">
                                <h3 className="text-sm font-bold uppercase tracking-wide text-gray-600 mb-3">Datos del cupón</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                    <DetailItem label="Fecha de procesamiento" value={dataCupon?.fecha_procesamiento} />
                                    <DetailItem label="Fecha de factura" value={dataCupon?.fecha_factura} />
                                    <DetailItem label="Nro. de factura" value={dataCupon?.nro_factura} />
                                    <DetailItem label="Timbrado" value={dataCupon?.timbrado} />
                                    <DetailItem label="Procesado por" value={dataCupon?.procesado_por} />
                                    <DetailItem label="Estado" value={dataCupon?.anulado === "1" ? "Anulado" : "Activo"} />
                                </div>
                            </div>

                            <div className="rounded-xl bg-white p-5 shadow-md border border-gray-200">
                                <h3 className="text-sm font-bold uppercase tracking-wide text-gray-600 mb-3">Comercio y facturación</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                                    <DetailItem label="ID local" value={dataCupon?.local_id} />
                                    <DetailItem label="Nombre fantasía" value={dataCupon?.nombre_fantasia} />
                                    <DetailItem label="RUC emisor factura" value={dataCupon?.ruc_emisor_factura} />
                                    <DetailItem label="RUC cliente factura" value={dataCupon?.ruc_cliente_factura} />
                                    <DetailItem label="Monto base" value={dataCupon?.monto} />
                                    <DetailItem label="ID sorteo" value={dataCupon?.sorteo_id} />
                                </div>
                            </div>

                            <div className="rounded-xl bg-white p-5 shadow-md border border-gray-200">
                                <h3 className="text-sm font-bold uppercase tracking-wide text-gray-600 mb-3">Observación</h3>
                                <div className="min-h-[84px] rounded-lg border border-dashed border-gray-300 bg-gray-50 p-3 text-sm text-gray-700 whitespace-pre-line">
                                    {dataCupon?.observacion?.trim() ? dataCupon.observacion : "Sin observaciones"}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="rounded-xl bg-white p-8 shadow-md text-center text-gray-600">
                            No se encontraron datos para este cupón.
                        </div>
                    )}
                </div>
            </div>


            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default DetalleCuponPage;